import EmptyState from "ds/components/EmptyState";
import { EmptystateCalendarClockColored } from "components/icons/generated";

const WorkerPoolQueuedRunsEmpty = () => {
  return (
    <EmptyState
      title="No schedulable runs found"
      icon={EmptystateCalendarClockColored}
      caption="You have no schedulable runs, everything is running smoothly."
    />
  );
};

export default WorkerPoolQueuedRunsEmpty;
